import React, { Component } from 'react';
import { Row, Col, Button, Form, FormGroup, Label, Input, Alert } from 'reactstrap';
import { Link } from 'react-router-dom';

class ReactivateUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
    };
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const { reactivateUser } = this.props;

    const { doNotSendEmail } = this.props.location.state || {};

    if (reactivateUser) {
      reactivateUser({
        email: this.state.email,
        activationEmail: doNotSendEmail?false:true
      });
    }
  };

  render() {
    const {
      companyDetails,
      reactivateUserState,
      logoutUrl = '/login',
    } = this.props;

    
    const companyName = companyDetails && companyDetails.data != null ? companyDetails.data.description : '';

    const isLoading =
      reactivateUserState && reactivateUserState.isLoading;

    const isSuccess = reactivateUserState && !reactivateUserState.isLoading && !reactivateUserState.hasError && reactivateUserState.data;

    return (
      <Row className="h-100 d-flex align-items-center justify-content-center public-user-page">
        <Col xs="12" sm="10" md="4">
          {companyName ? (
            <h4 className="brand-name player">{companyName}</h4>
          ) : (
            <h4 className="brand-name player">
              APTO<span className="ats">.AI</span>
            </h4>
          )}
          {
            isSuccess && ( <> <Alert color="success"> <i className="fa fa-check"></i>{reactivateUserState.data.message} </Alert> <Link className="mt-4 d-block text-center bg-white p-2 rounded" to={logoutUrl} > Continue to login </Link> </> )
          }

          <Form
            onSubmit={this.handleSubmit}
            className="player-public-user-form p-4"
          >
            <h5 className="text-center mb-3">
              Reactivate your account
            </h5>

            <FormGroup>
              <Label for="email">Enter your email</Label>
              <Input
                id="email"
                name="email"
                type="email"
                value={this.state.email}
                onChange={(event) =>
                  this.setState({ email: event.target.value })
                }
                placeholder="Email"
                required
              />
            </FormGroup>

            <Button
              disabled={isLoading || isSuccess}
              className="mt-4"
              color="primary"
              block
              type="submit"
            >
              {isLoading ? 'Please wait...' : 'Reactivate User'}
            </Button>

            <Link
              className="mt-4 d-block text-center"
              to={logoutUrl}
            >
              <i
                className="fa fa-arrow-left mr-1"
                aria-hidden="true"
              ></i>
              Back to login
            </Link>
          </Form>
        </Col>
      </Row>
    );
  }
}

export default ReactivateUser;
